import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

connect() {
  this.onKeydown = this.onKeydown.bind(this)
  document.addEventListener("keydown", this.onKeydown)
  this.syncActiveState()

  if (sessionStorage.getItem("cardFilterOpen") === "true") {
    this.panelTarget.classList.remove("hidden")
  }
}

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  onKeydown(e) {
    if (e.key.toLowerCase() === "f" && !e.metaKey && !e.ctrlKey && !e.altKey) {
      if (document.activeElement.tagName === "INPUT") return
      e.preventDefault()
      this.toggle()
    }
  }

  toggle() {
    const isHidden = this.panelTarget.classList.toggle("hidden")
    sessionStorage.setItem("cardFilterOpen", !isHidden)
  }

  syncActiveState() {
  const url = new URL(window.location.href)

  this.element.querySelectorAll(".filter-btn").forEach(btn => {
    const type = btn.dataset.filterType
    const value = btn.dataset.filterValue
    const paramValues = url.searchParams.getAll(type + "[]")

    if (paramValues.includes(value)) {
      btn.classList.add("filter-btn-active")
    } else {
      btn.classList.remove("filter-btn-active")
    }
  })
}
}
